import { jsx as _jsx } from "react/jsx-runtime";
import WorkflowDetailList from 'automation-contextual-components/WorkflowDetailList';

const CampaignReportingWorkflowCell = ({
  flows
}) => {
  const flowsAsExternalLinks = flows && flows.map(flow => ({
    id: flow.flowId,
    isExternalLink: true
  }));
  return /*#__PURE__*/_jsx(WorkflowDetailList, {
    details: flowsAsExternalLinks
  });
};

export default CampaignReportingWorkflowCell;